import React from 'react';
import Layout from '../Layout';
import Seo from '../Seo';
import Header from '../Header';
import Main from '../Main';
import Footer from '../Footer';
import '../../styles/global.scss';

interface AppProps {
  node: {
    id: string;
    html: string;
    frontmatter: {
      lang: string;
      title: string;
      description: string;
      thumbnail: any;
      song: {
        title: string;
        image: any;
        imageAlt: string;
        url: string;
      };
    };
  };
}

const App = ({ node }: AppProps) => {
  const { html, frontmatter } = node;

  return (
    <Layout>
      <Seo
        lang={frontmatter.lang}
        title={frontmatter.title}
        description={frontmatter.description}
        thumbnail={frontmatter.thumbnail.childImageSharp.original.src}
      />
      <Header title={frontmatter.title} song={frontmatter.song} />
      <Main content={html} />
      <Footer songTitle={frontmatter.song.title} />
    </Layout>
  );
};

export default App;
